"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Business = _interopRequireDefault(require("@material-ui/icons/Business"));

var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _Email = _interopRequireDefault(require("@material-ui/icons/Email"));

var _ProfileItem = _interopRequireDefault(require("../ProfileItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column'
    },
    avatarContainer: {
      position: 'relative',
      width: 140,
      height: 140
    },
    avatar: {
      width: 140,
      height: 140
    },
    editIcon: {
      position: 'absolute',
      bottom: -5,
      right: -5,
      backgroundColor: 'rgba(150,150,150,0.8)',
      color: 'white',
      '&:hover': {
        backgroundColor: 'rgba(80,80,80,1)'
      }
    },
    name: {
      paddingLeft: 68
    }
  };
});

var ProfileHeader = function ProfileHeader(_ref) {
  var name = _ref.name,
      email = _ref.email,
      company = _ref.company,
      avatar = _ref.avatar,
      onClickAvatarEdit = _ref.onClickAvatarEdit,
      onClickEdit = _ref.onClickEdit,
      onChangeLanguage = _ref.onChangeLanguage,
      lang = _ref.lang;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    display: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.avatarContainer
  }, /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
    src: avatar,
    className: classes.avatar
  }), /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    className: classes.editIcon,
    onClick: onClickAvatarEdit
  }, /*#__PURE__*/_react["default"].createElement(_Edit["default"], null))), /*#__PURE__*/_react["default"].createElement(_core.Box, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "h4",
    className: classes.name
  }, name), /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_Email["default"], null),
    text: email,
    textLabel: "email"
  }), company && /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_Business["default"], null),
    text: company,
    textLabel: "company"
  }))), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: onClickEdit,
    variant: "outlined",
    style: {
      flexGrow: 0,
      alignSelf: 'flex-end'
    }
  }, "aanpassen"), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    display: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return onChangeLanguage('nl');
    },
    variant: lang === 'nl' ? 'outlined' : 'default',
    color: "primary"
  }, "nl"), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return onChangeLanguage('fr');
    },
    variant: lang === 'fr' ? 'outlined' : 'default',
    color: "primary"
  }, "fr")));
};

ProfileHeader.propTypes = {
  avatar: _propTypes["default"].string,
  company: _propTypes["default"].string,
  email: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  onChangeLanguage: _propTypes["default"].func.isRequired,
  onClickAvatarEdit: _propTypes["default"].func.isRequired,
  onClickEdit: _propTypes["default"].func.isRequired
};
var _default = ProfileHeader;
exports["default"] = _default;